import { useNavigate } from 'react-router-dom';

import { UserInitials } from '../../UserInitials/UserInitials';

import type { UserResponse } from '../../../types';

import styles from './UserRow.module.scss';

type Props = {
  user: UserResponse;
};

function UserRow({ user }: Props) {
  const navigate = useNavigate();

  const { id, firstName, lastName, email, role } = user;

  return (
    <tr onClick={() => navigate(`/users/${id}`)} className={styles.row}>
      <td>
        <UserInitials user={user} className={styles.initials} />
        {firstName} {lastName}
      </td>
      <td>{email}</td>
      <td>{role}</td>
    </tr>
  );
}

export { UserRow };
